import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { REACT_APP_API_URL } from '../../../../../../env';

const EditRoomTariffModal = ({ show, onHide, data, onRefresh, currentUserId = 1 }) => {
  const [formData, setFormData] = useState({
    PropertyID: '',
    RoomConfigID: '',
    RoomType: '',
    NoOfRooms: '',
    PricePerDay: '',
    ExtraPersonRate: '',
    EffectiveFromDate: '',
    EffectiveTillDate: ''
  });

useEffect(() => {
  if (data) {
    const formatDate = (dateValue) => {
      if (!dateValue) return new Date().toISOString().split('T')[0];
      if (dateValue.includes('T')) return dateValue.split('T')[0];
      return dateValue; 
    };

    setFormData({
      PropertyID: data.PropertyID || data.intPropertyID || '',
      RoomConfigID: data.RoomConfigID || data.intRoomConfigID || '',
      RoomType: data.RoomType || data.vchRoomType || '',
      NoOfRooms: data.NoOfRooms || data.vchNoOfRoomsAvailable || '',
      PricePerDay: data.PricePerDay || data.dcmPricePerDay || '',
      ExtraPersonRate: data.ExtraPersonRate || data.dcmExtraPersonRate || '',
      EffectiveFromDate: formatDate(data.EffectiveFromDate || data.dtmEffectDate),
      EffectiveTillDate: formatDate(data.EffectiveTillDate || data.dtmEffectTill)
    });
  }
}, [data]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const stagingData = [
        {
          RoomID: data && data.RoomID ? data.RoomID : 0,
          RoomNo: formData.RoomType || data.RoomNo || ''
        }
      ];

      const payload = {
        P_INTHOTELID: formData.PropertyID,
        P_INTROOMCONFIGID: formData.RoomConfigID || data.intRoomConfigID || data.INTROOMCONFIGID,
        P_INTCREATEDBY: currentUserId,
        P_VCHNOOFROOMS: formData.NoOfRooms,
        P_DCMPRICEPERDAY: formData.PricePerDay,
        P_DCMEXTRAPERSONRATE: formData.ExtraPersonRate,
        P_DTMEFFECTDATE: formData.EffectiveFromDate, 
        P_DTMEFFECTTILL: formData.EffectiveTillDate,
        stagingData
      };

      const resp = await axios.post(`${REACT_APP_API_URL}api/room-tariff/merge-room-details`, payload);
      if (resp.data && resp.data.success) {
        if (onRefresh) onRefresh();
        onHide();
      } else {
        console.error('Backend message:', resp.data);
        alert(resp.data.message || 'Something went wrong');
      }
    } catch (err) {
      console.error('Error updating tariff:', err);
      alert('Failed to update tariff. See console for details.');
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Room Tariff</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Room Type</Form.Label>
                <Form.Control
                  type="text"
                  name="RoomType"
                  value={formData.RoomType}
                  onChange={handleChange}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>No. of Rooms</Form.Label>
                <Form.Control
                  type="number"
                  name="NoOfRooms"
                  value={formData.NoOfRooms}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Price Per Day</Form.Label>
                <Form.Control
                  type="number"
                  name="PricePerDay"
                  value={formData.PricePerDay}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Extra Person Rate</Form.Label>
                <Form.Control
                  type="number"
                  name="ExtraPersonRate"
                  value={formData.ExtraPersonRate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Effective From Date</Form.Label>
                <Form.Control
                  type="date"
                  name="EffectiveFromDate"
                  value={formData.EffectiveFromDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Effective Till Date</Form.Label>
                <Form.Control
                  type="date"
                  name="EffectiveTillDate"
                  value={formData.EffectiveTillDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button type="submit" variant="secondary">Save Changes</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditRoomTariffModal;